/**
 * Copyright (c) Microblink Ltd. All rights reserved.
 */

export const defaultWasmModuleName = "BlinkIDImageCaptureWasmSDK";
export const nativeJsonizationEnabled = false;
